module.exports = __webpack_public_path__ + "static/img/2.2e4e861.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ban/2.png
// module id = ZChZ
// module chunks = 1